<template>
	<v-col class="purchase-report">
		<ModalSearch ref="modalSearch" @action="cari"></ModalSearch>
		<ModalDetail ref="modalDetail" :detailTransactionProduct="detailTransactionProduct"></ModalDetail>
		<div class="d-flex justify-space-between">
			<div class="text-h5 cl-primary">Laporan Pembelian Produk</div>
		</div>
		<div class="pt-1 pb-2 d-flex font-size-10 grey--text">
			<v-icon small color="grey">mdi-cart</v-icon>
			<div class="pl-2">Transaksi Produk</div>
			<div class="px-2">/</div>
			<div>Laporan Pembelian Produk</div>
		</div>
		<div class="mt-5">
			<v-row>
				<v-col cols="12" class="py-0 py-sm-3">
					<div class="d-flex justify-end">
						<v-btn depressed color="primary" class="white--text rounded-lg text-capitalize" @click="showSearch">
							<div class="d-flex">
								<v-icon small class="d-block d-sm-none">mdi-magnify</v-icon>
								<div class="d-none d-sm-block">Cari</div>
							</div>
						</v-btn>
						<v-btn depressed color="grey lighten-1" class="ml-3 white--text rounded-lg text-capitalize" @click="reset">Reset</v-btn>
					</div>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="12" class="pb-1">
					<v-card class="pa-3 elevation-0 rounded-lg hover-shadow">
						<v-tabs class="tabs-vo no-slider" v-model="currentTabs">
							<v-tab @click="getDataAll">Semua</v-tab>
							<v-tab @click="getDataWait">Menunggu</v-tab>
						</v-tabs>
					</v-card>
				</v-col>
			</v-row>
			<v-scroll-x-reverse-transition mode="in-out" :hide-on-leave="true">
				<div class="mt-5" v-if="!loading">
					<v-row v-if="listTransactionProduct.length > 0">
						<v-col cols="12" class="pt-0">
							<v-simple-table class="white-row table-vo table-history-bonus">
								<template v-slot:default>
									<thead class="">
										<tr>
											<th class="text-left" width="17%">Kode</th>
											<th class="text-left" width="25%">Nama Stockist</th>
											<th class="text-left" width="15%">Tanggal</th>
											<th class="text-center" width="10%">Status</th>
											<th class="text-right" width="30%">Total Harga(Rp)</th>
											<th class="text-center" width="3%">Detail</th>
										</tr>
									</thead>
									<tbody class="grey--text text--darken-3">
										<tr v-for="transaction in listTransactionProduct" :key="transaction.transaction_id">
											<td class="text-left">{{ transaction.transaction_code }}</td>
											<td class="text-left">
												<div>{{ transaction.transaction_seller_name }}</div>
												<div class="cl-primary font-weight-500">{{ transaction.transaction_seller_network_code }}</div>
											</td>
											<td class="text-left">{{ transaction.transaction_datetime | tanggaljam }}</td>
											<td class="text-center text-uppercase">
												<v-chip
												small
												:color="getTransactionStatus(transaction.transaction_status).color"
												class="font-weight-bold white--text text-uppercase"
												>{{ getTransactionStatus(transaction.transaction_status).label }}</v-chip>
											</td>
											<td class="text-right">{{ transaction.transaction_total_price | toNumber }}</td>
											<td class="text-center">
												<v-tooltip bottom>
													<template v-slot:activator="{ on, attrs }">
														<v-btn class="" fab dark x-small depressed color="primary" v-bind="attrs" v-on="on" @click.stop="getDetailAll(transaction.transaction_id)">
															<v-icon dark>mdi-text-box-search</v-icon>
														</v-btn>
													</template>
													<span>Detail</span>
												</v-tooltip>
											</td>
										</tr>
									</tbody>
								</template>
							</v-simple-table>
						</v-col>
					</v-row>
					<div class="mt-3" v-if="listTransactionProduct.length == 0">
						<v-row>
							<v-col cols="12" sm="12" md="12">
								<v-card class="py-3 elevation-0 hover-shadow rounded-lg">
									<NoData></NoData>
									<div class="pt-3 text-center cl-secondary">Tidak ada list transaksi yang dapat ditampilkan</div>
								</v-card>
							</v-col>
						</v-row>
					</div>
					<div v-if="listTransactionProduct.length > 0">
						<v-row justify="end">
							<v-col cols="12" sm="5" md="6" class="pl-1 pr-0 pb-1 pr-sm-3 pb-sm-3 d-flex justify-sm-start justify-end">
								<v-pagination v-model="pageAll" total-visible="5" class="d-flex justify-end vo-pagination no-button-focus" color="primary" :length="transactionProductPagination.total_page" @input="changePageAll"></v-pagination>
							</v-col>
							<v-col cols="12" sm="5" md="5" class="pb-0 pb-sm-3 my-auto text-right">
								<div class=" font-size-10">Menampilkan {{ transactionProductPagination.total_display }} data dari total {{ transactionProductPagination.total_data }} data</div>
							</v-col>
							<v-col cols="4" sm="2" md="1">
								<v-autocomplete :items="listLimit" v-model="limit" hide-details dense class="" placeholder="Data" color="primary" @input="changeLimitAll"></v-autocomplete>
							</v-col>
						</v-row>
					</div>
				</div>
			</v-scroll-x-reverse-transition>
			<div class="mt-4" v-if="loading">
				<v-row>
					<v-col cols="12" sm="12" md="12">
						<LoadData :loading="loading"></LoadData>
					</v-col>
				</v-row>
			</div>
		</div>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ModalSearch from './components/ModalSearch';
import ModalDetail from './components/ModalDetail';

export default {
	components: {
		ModalSearch, ModalDetail
	},
	data() {
		return {
			loading: false,
			currentTabs: 0,
			pageAll: 1,
			pageWait: 1,
			limit: '10',
			listLimit: [ '10', '20', '50', '100' ],
			params: [],
			transactionStatus: [
			{
				status: 'sukses',
				color: 'success',
				label: 'Sukses',
				icon: 'mdi-check-decagram-outline'
			},
			{
				status: 'menunggu',
				color: 'warning',
				label: 'Menunggu',
				icon: 'mdi-timer-sand'
			},
			{
				status: 'ditolak',
				color: 'error',
				label: 'Ditolak',
				icon: 'mdi-close-circle-outline'
			}
			]
		}
	},
	computed: {
		...mapState('transactionProduct', ['listTransactionProduct', 'transactionProductPagination', 'detailTransactionProduct']),
	},
	methods: {
		...mapActions('transactionProduct', ['getTransactionProductAll', 'getTransactionProductWait', 'getDetailTransactionProduct']),

		getTransactionStatus(status) {
			const transaction = this.transactionStatus.find(x => x.status === status)
			if (transaction) return transaction
				else {
					const nontransaction = {
						status: '',
						color: 'secondary',
						label: '',
						icon: ''
					}
					return nontransaction
				}
			},

			async getDataAll() {
				this.loading = await true
				this.getTransactionProductAll(this.queryString({sort: 'transaction_datetime', dir: 'DESC', limit:this.limit, page: this.pageAll, params: this.params})).then(() => {
					document.body.scrollTop = 0
					document.documentElement.scrollTop = 0
					this.loading = false
				})
			},
			async getDataWait() {
				this.loading = await true
				this.params = []
				this.getTransactionProductWait(this.queryString({sort: 'transaction_datetime', dir: 'DESC', limit:this.limit, page: this.pageWait, params: this.params})).then(() => {
					document.body.scrollTop = 0
					document.documentElement.scrollTop = 0
					this.loading = false
				})
			},
			getDetailAll(id) {
				this.getDetailTransactionProduct(id).then(() => {
					if (Object.keys(this.detailTransactionProduct).length > 0) this.$refs.modalDetail.modalShow()
				})
			},
			changePageAll(page) {
				this.pageAll = page
				this.getDataAll()
			},
			changeLimitAll(limit) {
				this.limit = limit
				this.pageAll = 1
				this.getDataAll()
			},
			changePageWait(page) {
				this.pageWait = page
				this.getDataWait()
			},
			changeLimitWait(limit) {
				this.limit = limit
				this.pageWait = 1
				this.getDataWait()
			},
			showSearch() {
				this.$refs.modalSearch.modalShow()
			},
			reset() {
				this.params = []
				this.pageAll = 1
				this.pageWait = 1
				this.getDataAll()
				this.$refs.modalSearch.reset()
			},
			cari(data) {
				this.params = []
				this.pageAll = 1
				this.currentTabs = 0
				this.waitingReport = false

				if(data.kode.value)
					this.params.push(data.kode)
				if(data.date.value)
					this.params.push(data.date)
				if(data.status.value)
					this.params.push(data.status)
				this.getTransactionProductAll(this.queryString({sort: 'transaction_datetime', dir: 'DESC', limit:this.limit, page: this.page, params: this.params})).then(() => {
					this.$refs.modalSearch.modalHide()
				})
			},
		},
		created(){
			this.$store.dispatch('setPageTitle', `Laporan Pembelian Produk`)
			this.getDataAll()
		}
	};
	</script>